import FooterLayout, { FooterLayoutProps } from './FooterLayout';
import MenuLayout, { MenurLayoutProps } from './MenuLayout';
import useAppLayout from 'state/hooks/use-app-layout';
import theme from '@monorepo/shared/src/themes/studentAppTheme';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { AppLayout, MenuPlacementType } from '@monorepo/shared/src/types';

export interface MainLayoutProps {
  menuProps?: MenurLayoutProps;
  footerProps?: FooterLayoutProps;
  backgroundImg?: string;
  children: React.ReactNode | any;
  scrollY?: boolean;
  gutterBottom?: boolean;
}

interface StyleProps extends AppLayout {
  backgroundImg?: string;
  scrollY?: boolean;
  gutterBottom?: boolean;
}

const getMainContainerHeight = (props: StyleProps): string => {
  const { scrollY, containerHeight, offset, menuPlacement, gutterBottom } = props;
  if (scrollY) return 'auto';

  let mainContainerHeight = containerHeight + offset.top;

  if (menuPlacement === MenuPlacementType.ASIDE && !gutterBottom) {
    mainContainerHeight += offset.bottom;
  }

  return theme.typography.pxToRem(mainContainerHeight);
};

const MainLayout: React.FC<MainLayoutProps> = ({
  menuProps,
  backgroundImg,
  footerProps,
  children,
  scrollY,
  gutterBottom,
}) => {
  const { children: footerChildren, ...restfooterProps } = footerProps ?? {};
  const appLayout = useAppLayout();
  const classes = useStyles({
    ...appLayout,
    backgroundImg,
    scrollY,
    gutterBottom,
  });

  return (
    <div className={classes.container}>
      <MenuLayout {...menuProps} />
      <main className={classes.main}>{children}</main>
      <FooterLayout {...restfooterProps}>{footerChildren}</FooterLayout>
    </div>
  );
};

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  container: {
    width: '100%',
    height: ({ scrollY }) => (scrollY ? 'auto' : '100%'),
    minHeight: ({ windowHeight }) => theme.typography.pxToRem(windowHeight),
    backgroundImage: ({ backgroundImg }) => `url(${backgroundImg})`,
    backgroundAttachment: 'fixed',
    backgroundPosition: '0% 50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'repeat-y',
    position: 'relative',
  },
  main: {
    width: '100%',
    height: getMainContainerHeight,
    paddingTop: ({ offset }) => theme.typography.pxToRem(offset.top),
    paddingLeft: ({ offset }) => theme.typography.pxToRem(offset.left),
    paddingRight: ({ offset }) => theme.typography.pxToRem(offset.right),
    paddingBottom: theme.typography.pxToRem(theme.constants.app.paddingY),
  },
}));

export default MainLayout;
